import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_API } from './url.api';
import { User } from '../model/User.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  userEmitter = new EventEmitter<any>();

  constructor(
    private http: HttpClient
  ) { }

  findById(id: number): Observable<User> {
    return this.http.get<User>(`${URL_API}/users/${id}`);
  }

  save(user: User, photo: File): Observable<any> {
    let formdata = new FormData();
    formdata.append('userInsert', JSON.stringify(user));
    formdata.append('file', photo);
    return this.http.post<any>(`${URL_API}/users`, formdata);
  }

  photo(user: User, photo: File): Observable<any> {
    let formdata = new FormData();
    formdata.append('photo', photo);
    return this.http.put<any>(`${URL_API}/users/${user.id}/photo`, formdata);
  }

  saveContact(user: User, sendmail: boolean): Observable<any> {
    return this.http.put<any>(`${URL_API}/users/contact/${sendmail}`, user);
  }

  update(user: User): Observable<any> {
    return this.http.put<any>(`${URL_API}/users/${user.id}`, user);
  }

  delete(user: User): Observable<any> {
    return this.http.delete<any>(`${URL_API}/users/${user.id}`);
  }

  profile(user: User): Observable<any> {
    return this.http.put<any>(`${URL_API}/users/${user.id}/profile`, user);
  }

  findByEmail(email: string): Observable<any> {
    return this.http.get<any>(`${URL_API}/users/email/${email}`);
  }

  findStatus(email: string): Observable<Boolean> {
    return this.http.get<Boolean>(`${URL_API}/users/status/${email}`);
  }

  forgot(email: string): Observable<any> {
    return this.http.get<any>(`${URL_API}/users/forgot/${email}`);
  }

  changepwd(email: string, pwd: any): Observable<any> {
    return this.http.put<any>(`${URL_API}/users/changepwd/${email}`, pwd);
  }

  findClientByUser(userId: number): Observable<any> {
    return this.http.get<any>(`${URL_API}/users/${userId}/customers`)
  }

  findUser(user: any) {
    return this.userEmitter.emit(user);
  }

  findByContactClient(client: any): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_API}/users/${client.id}/contacts`);
  }

  findDestForRepres(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_API}/users/recipients`);
  }

  findDestForRepresClient(user: any): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_API}/users/${user}/recipients`);
  }

  findDestForClient(client: any): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_API}/users/${client}/recipientsForClient`);
  }

  findDestAdmin(): Observable<Array<any>> {
    return this.http.get<Array<any>>(`${URL_API}/users/recipients/admin`);
  }

  findAll(): Observable<Array<User>> {
    return this.http.get<Array<User>>(`${URL_API}/users`);
  }
}
